import { render, staticRenderFns } from "./cloudfactory.vue?vue&type=template&id=18f43e88&"
import script from "./cloudfactory.vue?vue&type=script&lang=js&"
export * from "./cloudfactory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports